const EXAMPLES = {
  EMAIL: 'mail@example.com',
  NATIONALID: {
    SE: '19001122-1234',
    NO: '11028559912',
    FI: '010101+1234'
  },
  PHONE: {
    SE: '+46 07 123 456 78',
    NO: '+47 815 12 345',
    FI: '+358 40123 4567'
  },
  ZIPCODE: {
    SE: '111 99',
    NO: '0025',
    FI: '00100',
    DK: '2100'
  }
};

const REGEX = {
  EMAIL: "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$",
  PASSWORD: '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,15}$',
  NATIONALID: {
    SE: '^(19|20)?(\\d{6}([-+]|\\s)\\d{4}|(?!19|20)\\d{10})$',
    FI: '^[0-9]{6}[\\-|A]?(?:[0-9]+){1,3}[0-9A-Za-z]$',
    NO: '(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])\\d{2}( |-)?\\d{5}'
  },
  PHONE: {
    SE: /^(\+46|0046|0)(\s?[0]?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9])$/,
    NO: /^(\+47|0047|0)(\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9]\s?[0-9])$/,
    FI: /^(\+358|00358|0)(\s?[0-9]){8,9}$/
  },
  CARD: {
    NUMBER: '^(?:4[0-9]{12}(?:[0-9]{3})?|(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\\d{3})\\d{11})$',
    DATE: '^(0[1-9]|1[0-2])/([0-9]{2})$',
    CODE: '^[0-9]{3,4}$'
  },
  ZIPCODE: {
    SE: /^\d{3}\s?\d{2}$/,
    NO: /^\d{4}$/,
    FI: /^\d{5}$/,
    DK: /^\d{4}$/
  },
  NAME: '^[^,]*$',
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/
};

const validate = (value, regex) => RegExp(regex).test(value);

// TODO: Add error checks in these functions to avoid wrong param error
const validateNationalId = (id, country) => validate(id, REGEX.SSN[country.toUpperCase()]);
const validateEmail = (email) => validate(email, REGEX.EMAIL);
const validatePassword = (password) => validate(password, REGEX.PASSWORD);
const validatePhone = (phone, countries) => {
  const _countries = Array.isArray(countries) ? countries : [ countries ];

  return _countries.reduce(
    (res, country) => res && validate(phone, REGEX.PHONE[country.toUpperCase()]),
    true
  );
};
const validateCreditCardNumber = (card) => validate(card, REGEX.CARD.NUMBER);
const validateCreditCardDate = (date) => validate(date, REGEX.CARD.DATE);
const validateCreditCardCode = (code) => validate(code, REGEX.CARD.CODE);

export {
  EXAMPLES,
  REGEX,
  validateNationalId,
  validateEmail,
  validatePassword,
  validatePhone,
  validateCreditCardNumber,
  validateCreditCardDate,
  validateCreditCardCode
};
